import { createFileRoute } from "@tanstack/react-router";
import { studentsSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/students/")({
  head: () => ({
    meta: [{ title: "学员管理 · imiker CRM" }],
  }),
  validateSearch: studentsSearchSchema
});
